import React from 'react'

import clsx from 'clsx'
import copyToClipboard from 'copy-to-clipboard'

import { openToast } from '@insquad/tools'
import { useRouter } from 'next/router'

import { LinkIcon } from 'src/common/components/icons/LinkIcon'
import { FacebookSocialIcon } from 'src/common/components/icons/social/FacebookSocialIcon'
import { LinkedInSocialIcon } from 'src/common/components/icons/social/LinkedInSocialIcon'
import { TwitterSocialIcon } from 'src/common/components/icons/social/TwitterSocialIcon'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { APP_HOST_NAME } from 'src/utils/config'
import {
  getFacebookShareLink,
  getLinkedInShareLink,
  getTwitterShareLink,
} from 'src/utils/socialMedia'

import s from './AsideContentShare.module.scss'

const getIcons = (url: string) => [
  {
    icon: <FacebookSocialIcon />,
    onClick() {
      window.open(getFacebookShareLink({ url }), '_blank')
    },
  },
  {
    icon: <LinkedInSocialIcon />,
    onClick() {
      window.open(getLinkedInShareLink({ url }), '_blank')
    },
  },
  {
    icon: <TwitterSocialIcon />,
    onClick() {
      window.open(getTwitterShareLink({ url }), '_blank')
    },
  },
]
export type AsideContentShareProps = {
  className?: string
}

export const AsideContentShare: React.FC<AsideContentShareProps> = ({
  className,
}) => {
  const router = useRouter()
  const url = APP_HOST_NAME + router.asPath

  const handleLinkClick = () => {
    copyToClipboard(url)
    openToast({ text: 'Link copied to clipboard' })
  }

  return (
    <div className={clsx(s.AsideContentShare, className)}>
      <Typography
        className={s.AsideContentShare__title}
        variant={EnumTypographyVariants.H5}
        as="div"
      >
        Share this case
      </Typography>

      <div className={s.AsideContentShare__icons}>
        {getIcons(url).map(({ icon, onClick }, i) => (
          <button
            key={i}
            onClick={onClick}
            className={s.AsideContentShare__icon}
          >
            {icon}
          </button>
        ))}

        <button
          className={clsx(
            s.AsideContentShare__btnReset,
            s.AsideContentShare__icon
          )}
          onClick={handleLinkClick}
        >
          <LinkIcon />
        </button>
      </div>
    </div>
  )
}
